import {getSettings} from '../../selectors/selectors';
import store from '../../store/store';

const validPattern = /^[-\d\s+]*$/;

const contactNumber = (regexByLocaleList = []) => (value) => {
  const state = store.getState();
  
  if (!value) return;
  
  const trimmedValue = value.trim();
  
  if (!(validPattern.test(trimmedValue))) {
    return 'errors.formFields.invalidContactNumber';
  }
  
  if (regexByLocaleList.length > 0 && !regexByLocaleList.some(regexByLocale => regexByLocale.test(trimmedValue))) {
    const noneMatchRegex = regexByLocaleList.find(regexByLocale => !regexByLocale.test(trimmedValue));
    
    if (noneMatchRegex) {
      const stringRegex = noneMatchRegex.toString();
      
      const contactNumberFormat = stringRegex.substring(
        stringRegex.lastIndexOf('(') + 1,
        stringRegex.lastIndexOf(')'),
      );
  
      const ukMobileRegex = new RegExp('(\\+447|447)|(07|\\+07)');
      
      if (getSettings(state)?.should_use_uk_mobile_validation_only && stringRegex.match(ukMobileRegex)) {
        return ['errors.formFields.invalidContactNumber.format', '07 or +44'];
      }
      
      return ['errors.formFields.invalidContactNumber.format', contactNumberFormat.replace(/\\/g, '')?.trim()];
    }
  }
};

export default contactNumber;
